var map = {
	"./bash": 2060,
	"./java": 2061,
	"./json": 2062,
	"./julia": 2063,
	"./python": 2064,
	"./r": 2065,
	"./rust": 2066,
	"./scala": 2067,
	"./shell": 2068,
	"./sql": 2069,
	"./xml": 2070,
	"./yaml": 2071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2059;